export default class ShipmentDetailsInConditionExcept_62_305_6009 {
    constructor(warehouseId, shipmentId, encryptedShipmentId, orderId, asin, quantity, orderDate, promisedShipDate, shipMethod, expectedShipDate, condition, conditionAge, hoursPassedExsd, shipmentType) {
        this.warehouseId = warehouseId;
        this.shipmentId = shipmentId;
        this.encryptedShipmentId = encryptedShipmentId;
        this.orderId = orderId;
        this.asin = asin;
        this.quantity = quantity;
        this.orderDate = orderDate;
        this.promisedShipDate = promisedShipDate;
        this.shipMethod = shipMethod;
        this.expectedShipDate = expectedShipDate;
        this.condition = condition;
        this.conditionAge = conditionAge;
        this.hoursPassedExsd = hoursPassedExsd;
        this.shipmentType = shipmentType;
    }
}
